<template>
  <v-avatar v-if="!data[field]" :color="currentColor" :size="size">
    <span :class="classText" :style="{ fontSize: fontSize + 'px' }">{{
      data.name | shortName
    }}</span>
  </v-avatar>
  <v-avatar v-else :size="size">
    <img :alt="field" :src="data[field]" />
  </v-avatar>
</template>

<script>
import { getRandomColor } from '@src/utils'
export default {
  props: {
    data: {},
    size: { type: [Number, String], default: 48 },
    field: { type: String, default: 'avatar_url' },
    color: { type: String, default: '' },
    classText: { type: String, default: null },
  },
  data: () => ({}),
  computed: {
    fontSize() {
      return Math.round(this.size / 3, 0)
    },
    currentColor() {
      return this.color || getRandomColor()
    },
  },
}
</script>

<style></style>
